export class RefreshTokenViewModel {
  AuthToken: string | undefined;
  RefreshToken: string | undefined;


}
